
import { defineComponent, PropType } from 'vue'
import { sendTransferContactService } from '@entities/analytics'
import { AppButton } from '@shared/ui'

interface IData {
  phone: string
  errorPhone: boolean
}
export default defineComponent({
  name: 'ReviewCollectingContacts',

  components: {
    BaseButton: AppButton
  },

  props: {
    advertisingActive: {
      type: Boolean as PropType<boolean>,
      required: true,
      default: true
    }
  },

  emits: ['toggleAdvertisingActive', 'closeCollectingContactsModal', 'toggleConsentMailing'],

  data (): IData {
    return {
      phone: '',
      errorPhone: true
    }
  },

  watch: {
    phone () {
      // eslint-disable-next-line no-useless-escape
      const phone = this.phone.replace(/[^\+\d]/g, '')
      if (phone.length === 12) {
        this.errorPhone = false
      } else {
        this.errorPhone = true
      }
    }
  },
  methods: {
    toggleAdvertisingActive (): void {
      this.$emit('toggleAdvertisingActive')
    },

    closeCollectingContactsModal (): void {
      this.$emit('closeCollectingContactsModal')
    },

    toggleConsentMailing (): void {
      this.$emit('toggleConsentMailing')
    },

    sendNumber (): void {
      const numberPhone = this.phone.toString()
      sendTransferContactService(numberPhone.replace(/[^+\d]/g, ''))
      this.closeCollectingContactsModal()
    }
  }
})
